import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 621px;
  /* altura automática, mas limite se quiser: max-height: 90vh; */
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
`;

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitleText = styled.h2`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Você pode usar margin-bottom caso queira mais espaço antes do Footer */
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
`;

export const Input = styled.input`
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #e7eaf0;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  color: #333333;

  ::placeholder {
    color: #999999;
  }
`;

export const Select = styled.select`
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #e7eaf0;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  color: #333333;

  option {
    font-family: Inter, sans-serif;
    font-size: 14px;
    color: #333333;
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const PrimaryButton = styled.button`
  background: #2d5bff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;

export const SecondaryButton = styled.button`
  background: #ffffff;
  color: #2d5bff;
  border: 1px solid #2d5bff;
  border-radius: 8px;
  padding: 10px 24px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;
